<script>
  export let type = '';
  export let title = '';
  export let value = '';
</script>

{#if title}
  <span class="d-block d-lg-none spec-modal__line-title_mob">{title}</span>
{/if}
<span class="{type == 'km_0_100' ? 'text-bold' : ''}">
  {value ? value : '-'}
</span>

<style lang="scss">
  .spec-modal__line-title_mob {
    font-weight: bold;
    font-size: 15px;

    @media (min-width: 576px) {
      margin-bottom: 2px;
      font-size: 16px;
    }
  }

  .text-bold {
    font-weight: bold;
  }
</style>